import { openDB } from 'idb';
import "randomcolor";
import { getRandomIntInclusive, randomCustomColor } from '../utils/utils';
export class PinnedDB {
    static async initDB() {
        const db = await openDB('Pinned', 1, {
            upgrade(db) {
                const store = db.createObjectStore('pinned', {
                    keyPath: 'id',
                    autoIncrement: true,
                });
                store.createIndex('createdAt', 'at');
            },
        });
        if (!db) {
            throw 'connection to db terminated';
        }
        this.db = db;
    }
    static async create(pinned) {
        return PinnedDB.db.add('pinned', Object.assign(Object.assign({}, pinned), { createdAt: ~~(Date.now() / 1000), color: randomCustomColor(), top: getRandomIntInclusive(0, 25), left: getRandomIntInclusive(0, 25) }));
    }
    static async setCoord(key, top, left) {
        const pinned = await PinnedDB.db.get('pinned', key);
        PinnedDB.db.put('pinned', Object.assign(Object.assign({}, pinned), { top, left, lastEdit: (~~(Date.now() / 1000)) }));
    }
    static async get(key) {
        return await PinnedDB.db.get('pinned', key);
    }
    static async getAllActive() {
        return (await PinnedDB.db.getAll('pinned')).filter(p => {
            return !p.done;
        }).sort((a, b) => { return a.id < b.id ? -1 : 1; });
    }
    static async remove(key) {
        return await PinnedDB.db.delete('pinned', key);
    }
    static async removeAll() {
        await PinnedDB.db.clear('pinned');
    }
    static async setDone(key) {
        const pinned = await PinnedDB.db.get('pinned', key);
        PinnedDB.db.put('pinned', Object.assign(Object.assign({}, pinned), { done: true, doneAt: (~~(Date.now() / 1000)) }));
    }
    static async dbCleanUp(maxDayAge = 3) {
        const pinned = await PinnedDB.db.getAll('pinned');
        pinned.forEach(p => {
            if (p.doneAt < ((~~(Date.now() / 1000)) - (maxDayAge * 86400)))
                PinnedDB.db.delete('pinned', p.id);
        });
    }
}
